import React, { useEffect, useState } from "react";
import { api, brl, eletrosMediaUrl } from "../../lib/api";
import { Boxes, AlertTriangle, XCircle, Package, Filter, Zap } from "lucide-react";

const PURPLE = "#2B1E4A";
const STATE = { ok: ["OK", "bg-emerald-100 text-emerald-700"], low: ["Estoque baixo", "bg-amber-100 text-amber-700"], out: ["Sem estoque", "bg-red-100 text-red-700"] };

export default function AdminEletrosEstoque() {
  const [data, setData] = useState(null);
  const [f, setF] = useState({ category: "", brand: "", status: "" });

  const load = async () => {
    const params = Object.fromEntries(Object.entries(f).filter(([, v]) => v));
    setData((await api.get("/eletros/inventory/summary", { params })).data);
  };
  useEffect(() => { load(); /* eslint-disable-line */ }, []);

  if (!data) return <div className="p-6 text-sm text-[#5C5A57]">Carregando...</div>;

  return (
    <div className="space-y-6 p-4 lg:p-8" data-testid="admin-eletros-estoque-page">
      <div className="flex items-center gap-3 rounded-2xl p-5 text-white" style={{ background: `linear-gradient(135deg, ${PURPLE}, #5B2CA0)` }}>
        <div className="grid h-12 w-12 place-items-center rounded-xl" style={{ background: "#F5B400" }}><Boxes size={24} className="text-[#2B1E4A]" /></div>
        <div>
          <div className="text-[11px] font-bold uppercase tracking-[0.2em]" style={{ color: "#F5B400" }}>Eletros</div>
          <h1 className="font-display text-xl font-bold">Estoque</h1>
          <p className="text-[12px] text-white/70">{data.total_products} produtos · alertas de estoque</p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <Mini icon={AlertTriangle} label="Estoque baixo" value={String(data.low_count)} amber />
        <Mini icon={XCircle} label="Sem estoque" value={String(data.out_count)} red />
        <Mini icon={Package} label="Valor investido" value={brl(data.invested_value)} />
        <Mini icon={Zap} label="Valor potencial venda" value={brl(data.potential_value)} gold />
      </div>

      <div className="rounded-2xl border border-border bg-white p-5">
        <div className="mb-3 flex flex-wrap items-center gap-2">
          <div className="flex items-center gap-1 text-sm font-semibold text-brand-dark"><Filter size={15} /> Filtros</div>
          <select value={f.category} onChange={(e) => setF({ ...f, category: e.target.value })} data-testid="estoque-filter-category" className="inp w-auto">
            <option value="">Categoria</option>{data.categories.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
          <select value={f.brand} onChange={(e) => setF({ ...f, brand: e.target.value })} data-testid="estoque-filter-brand" className="inp w-auto">
            <option value="">Marca</option>{data.brands.map((b) => <option key={b} value={b}>{b}</option>)}
          </select>
          <select value={f.status} onChange={(e) => setF({ ...f, status: e.target.value })} data-testid="estoque-filter-status" className="inp w-auto">
            <option value="">Todos</option><option value="low">Estoque baixo</option><option value="out">Sem estoque</option><option value="ok">OK</option>
          </select>
          <button onClick={load} data-testid="estoque-apply" className="rounded-xl px-4 py-2 text-sm font-semibold text-white" style={{ background: PURPLE }}>Aplicar</button>
        </div>

        <div className="space-y-2" data-testid="estoque-list">
          {data.items.length === 0 ? <div className="py-6 text-center text-sm text-[#9A8A98]">Nenhum produto.</div> :
            data.items.map((p) => {
              const [label, cls] = STATE[p.state] || STATE.ok;
              return (
                <div key={p.id} className="flex items-center gap-3 rounded-xl border border-border p-3" data-testid={`estoque-item-${p.id}`}>
                  <div className="grid h-12 w-12 shrink-0 place-items-center overflow-hidden rounded-lg bg-[#F1ECF7]">
                    {p.cover_image ? <img src={eletrosMediaUrl(p.cover_image)} alt="" className="h-full w-full object-cover" /> : <Zap size={18} className="text-[#B7A6C9]" />}
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="truncate font-medium text-brand-dark">{p.name}</div>
                    <div className="text-[12px] text-[#8A7788]">{[p.brand, p.category].filter(Boolean).join(" · ")}</div>
                    <div className="text-[11px] text-[#9A8A98]">Estoque {p.stock} · min {p.min_stock_alert} · investido {brl(p.invested)}</div>
                  </div>
                  <span className={`shrink-0 rounded-full px-2.5 py-1 text-[10px] font-bold uppercase ${cls}`}>{label}</span>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}

function Mini({ icon: Icon, label, value, amber, red, gold }) {
  const color = red ? "#DC2626" : amber ? "#B45309" : gold ? "#C9960A" : PURPLE;
  return (
    <div className="rounded-2xl border border-border bg-white p-4" data-testid={`estoque-mini-${label}`}>
      <Icon size={18} className={red ? "text-red-500" : amber ? "text-amber-500" : gold ? "text-[#C9960A]" : "text-[#5B2CA0]"} />
      <div className="mt-2 text-[10px] uppercase tracking-widest text-[#9A8A98]">{label}</div>
      <div className="font-display text-lg font-bold" style={{ color }}>{value}</div>
    </div>
  );
}
